import {createComponent} from '../bridge/create-component';
import type {BridgeComponentOptions} from '../bridge/types';
import {containerTemplate} from '../container';
import type {CardInputProps} from './types';
import {transformStyle, validateComponentProps} from '../utils';
import {config} from '../config';
import {getPaymentMethods} from '../api';

export * from './types';

const getCreateTokenFunction = (ref: any) => {
  if (ref.state?.__createToken) {
    return ref.state.__createToken;
  }
  throw new Error('Index is not registered');
};

export const createToken = async (
  component?: any,
  options?: any
): Promise<{token?: string; error?: string; paymentMethod: 'card'}> => {
  console.warn('[MONEI] Standalone createToken() is deprecated. Use cardInput.submit() instead.');
  const {data} = await getCreateTokenFunction(component)(options);
  return {...data, paymentMethod: 'card' as const};
};

const componentOptions: BridgeComponentOptions<CardInputProps> = {
  tag: 'monei-card-input',
  url: config.cardInputUrl,
  dimensions: {
    width: '100%',
    height: 'auto'
  },
  autoResize: {
    width: false,
    height: true
  },
  aliases: {
    sessionId: 'orderId',
    style: 'innerStyle'
  },
  computedProps: {
    __getConfig: {
      factory: ({props}) => getPaymentMethods.bind(null, props),
      type: 'function'
    }
  },
  validate: validateComponentProps,
  submit: (instance) => async (opts?: any) => {
    const createTokenFn = instance.state?.__createToken;
    if (!createTokenFn) {
      throw new Error('CardInput is not rendered or connection is pending — call render() first');
    }
    const {data} = await createTokenFn(opts);
    return {...data, paymentMethod: 'card' as const};
  },
  containerTemplate: (params) => {
    // Set createToken on state — uses callChild (available after Penpal connects).
    // createToken is only called after user fills card, so connection is always ready.
    params.state.__createToken = async (data: any = {}) => {
      const callChild = params.state.__callChild;
      if (!callChild) {
        throw new Error('CardInput instance is not registered');
      }
      return {data: await callChild('createToken', [data])};
    };
    return containerTemplate(params);
  },
  prerenderTemplate: ({doc, props}) => {
    const html = doc.createElement('html');
    const body = doc.createElement('body');
    body.style.margin = '0';
    body.style.background = '#fff';
    const div = doc.createElement('div');
    div.style.height = '45px';
    div.style.boxSizing = 'border-box';
    const style = props.style || (props as any).innerStyle;
    if (style?.base) {
      Object.assign(div.style, transformStyle(style.base));
    }
    if (style?.loading) {
      Object.assign(div.style, transformStyle(style.loading));
    }
    body.appendChild(div);
    html.appendChild(body);
    return html;
  }
};

export const CardInput = createComponent<CardInputProps>(componentOptions);
